var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"switch",class:_vm.wrapperCss},[_vm._t("before",null,{"on":_vm.isOn}),_vm._v(" "),_c('span',{staticClass:"switch-wrapper",on:{"click":_vm.toggle}},[_c('span',{staticClass:"switch-handle"})]),_vm._v(" "),_vm._t("after",null,{"on":_vm.isOn})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }